import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["subtotal"];

  getChecked() {
    return $(".processing-checkbox:checkbox:checked");
  }

  calculate() {
    let checked = this.getChecked();
    let subtotal = {};
    if (checked.length > 0) {
      $(checked).each(function () {
        let quantity = this.closest("form").querySelector("#transaction_item_quantity").value;
        let unit_price = this.closest("form").querySelector("#transaction_item_unit_price").value;
        let unit_subtotal = quantity * unit_price;
        let currency = this.closest("form").querySelector("#transaction_item_currency").value;
        if (currency in subtotal) {
          let val = subtotal[currency];
          subtotal[currency] = val + unit_subtotal;
        } else {
          subtotal[currency] = unit_subtotal;
        }
      });
    }
    let str_subtotal = Object.keys(subtotal)
      .map((key) => `${key}: ${subtotal[key]}`)
      .join(", ");
    this.subtotalTarget.innerText = "Selected Subtotal: " + str_subtotal;
  }
}
